import { Injectable, EventEmitter, HostListener } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  constructor(private updates: SwUpdate) {
    this.registerCheckForUpdates();
  }

  newVersion$ = new EventEmitter<boolean>(false);
  oldVersion: any;
  newVersion: any;

  registerCheckForUpdates() {
    //source: https://angular.io/guide/service-worker-communications
    if (!this.updates.isEnabled) {
      // console.debug('appService', 'checkForUpdates', 'SwUpdate is not enabled', new Date());
      return;
    }

    const updatesAvailable = this.updates.versionUpdates.pipe(
      filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'),
      map(evt => ({
        type: 'UPDATE_AVAILABLE',
        current: evt.currentVersion,
        available: evt.latestVersion,
      })))
      .subscribe(event => {
        this.oldVersion = event.current;
        this.newVersion = event.available;
        this.newVersion$.emit(true);
      });
  }
  checkForUpdatesNow() {
    if (!this.updates.isEnabled) {
      // console.debug('appService', 'checkForUpdatesNow', 'SwUpdate is not enabled', new Date());
      return;
    }
    // console.debug('appService', 'checkForUpdatesNow', 'check for updates....', new Date());
    this.updates.checkForUpdate();
  }

  update() {
    // console.debug('appService', 'update', 'updating app...', new Date());
    this.updates.activateUpdate().then(() => window.location.reload());
  }

  readyToInstall: boolean;
  deferredPrompt: any;
  @HostListener('window:beforeinstallprompt', ['$event'])
  onbeforeinstallprompt(e) {
    e.preventDefault();
    this.deferredPrompt = e;
    this.readyToInstall = true;
  }
  promptInstall() {
    this.readyToInstall = false;
    this.deferredPrompt.prompt();
    this.deferredPrompt.userChoice
      .then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the A2HS prompt');
        } else {
          console.log('User dismissed the A2HS prompt');
        }
        this.deferredPrompt = null;
      });
  }
}
